import React, { useRef, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { OnLogin, SignUpUser } from './../Redux/action'
import { useForm } from "react-hook-form";
import Logo from './../assist/triokzzlohgo.svg';
import firebase from 'firebase/compat/app';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import SigninForm from './../admin/signin'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MESURMENTID,
        databaseURL: "https://loginwithphone-9fb64.firebaseio.com/"
};

// const firebaseConfig = {
//     apiKey: "AIzaSyB8YeifobKfJJSO3nselAILteDgp4iIAMA",
//     authDomain: "loginwithphone-9fb64.firebaseapp.com",
//     projectId: "loginwithphone-9fb64",
//     storageBucket: "loginwithphone-9fb64.appspot.com",
//     messagingSenderId: "395072549821",
//     appId: "1:395072549821:web:4f59770be42fda341a98d4",
//     measurementId: "G-RWZEXW6VMP"
// };

// Initialize Firebase

firebase.initializeApp(firebaseConfig);

// const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const Signin = (props) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { state } = useLocation();
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const password = watch("password");
    // const [mynumber, setnumber] = useState("");
    const mynumber = watch("phone");
    const [otp, setotp] = useState(new Array(6).fill(''));
    const [show, setshow] = useState(false);
    const [showloader, setshowloader] = useState(false);
    const [final, setfinal] = useState("");
    const [JWebToken, setJWebToken] = useState({})
    const [varified, setverified] = useState(false)
    const [messageStatus, setMessageStatus] = useState('');
      let ListOfOrdered = useSelector(state => state.allProducts.order)
    //   console.log(otp)
    // console.log("mynumber ", Object.keys(props).length === 0)
    // Sent OTP
    const verify = async() => {
        if (mynumber === "" || mynumber.length < 10) return;
        setshowloader(true)

        // let verify = new firebase.auth.RecaptchaVerifier(
        //     'recaptcha-container');
        let verifyed = await new firebase.auth.RecaptchaVerifier(
            'recaptcha-container', {
            size: "invisible",
            callback: function (response) {
                console.log('workrs')
            }
        })
        verifyed.render()
        verifyed.verify()
        // console.log("mynumber ", mynumber, verifyed)
        firebase.auth().signInWithPhoneNumber(`+91${mynumber}`, verifyed)
            .then((result) => {
                setfinal(result);
                toast(
                    <span>
                        <b>OTP Sent To Your Mobile Number</b>
                    </span>,
                    {
                        icon: '😀☞',
                    }
                )
                setshow(true)
            })
            .catch((err) => {
                alert(err);
                // window.location.reload();
            });
    };

    // Validate OTP
    const ValidateOtp = async() => {
        if (otp === null || final === null) return;
        await final
            .confirm(otp)
            .then((result) => {
  
                localStorage.setItem('PHONEOTPINFO', JSON.stringify(result && result.user && result.user.multiFactor && result.user.multiFactor.user))
                firebase.auth().signOut().then((r) => {
                    // Sign-out successful.
                    toast(
                        <span>
                            <b>Authenticate successfully, Please submit</b>
                        </span>,
                        {
                            icon: '🤝',
                        }
                    )
                    setshowloader(false)
                    setverified(true)
                }).catch((error) => {
                    console.log(error)
                    // An error happened.
                })
            })
            .catch((err) => {
                console.log(err)
                alert("Please Enter Correct OTP");

            });
            // sendMessage()
    };

    const onSubmit = (data) => {
        // await sleep(2000);
        // console.log(data)
        // if (data.email == "client17@gmail.com" && data.password == "Client17") {
        //     navigate('/clientproducts', { state: data })
        // } else if (data.email == "triokzz0@gmail.com" && data.password == "triokzz9800") {
        //     navigate('/checkout', { state: data })
        // }
        dispatch(SignUpUser(data, props, state, navigate))
    }

    const handleButtonClick = (event) => {
        console.log('Submit button clicked!');
        event.preventDefault()
        // Perform pre-submission actions or specific logic
    };

    return (
        <div className="p-2">
            {state && state.role && <nav className="flex-col grid grid-cols-2 items-center justify-between text-black p-2">
                <div className="flex items-center flex-shrink-0 text-black mr-6" >
                    <img
                        className="h-14 w-25"
                        src={Logo}
                        width="100%" height="100%"
                        alt="Paithani, grocery, skin care, shankara naturals, amazo, Solid T-shirt,Plain T-Shirt,Buy Plain Solid T-shirts,printo mug, Bewakoofy items, home decor items, sculptures, inspiring, large luggage bags, popular duffle, touring bags, big size travel bags online, purse, wholesale mugs, custom cups and mugs, ceramic printed mugs, copper drinking mugs, cups for camping, purses for women, purse sale, branded bags for women, multi pocket bags"

                    />
                    <div className="flex">
                        <a href="/signin/seller" className="rounded-md px-2 py-1 text-sm font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Home</a>
                        <a href="/about" className="rounded-md px-2 py-1 text-sm font-medium text-gray-400 hover:bg-gray-700 hover:text-white">About</a>
                        <a href="/contact" className="rounded-md px-2 py-1 text-sm font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Contact</a>
                        <a href="/faq" className="rounded-md px-2 py-1 text-sm font-medium text-gray-400 hover:bg-gray-700 hover:text-white">FAQ</a>
                        <a href="/sellerpolicy" className="rounded-md px-2 py-1 text-sm font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Policy</a>
                    </div>

                </div>
            </nav>}
            <div class="flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" color="oklch(57.7% 0.245 27.325)" />
                </svg>
            </div>
            <h3 className="font-bold">SignUp</h3>
            <form onSubmit={e => e.preventDefault()} className="space-y-2 border p-2" action="#" method="POST">
                <div>
                    <div className="mt-2">
                        <input id="firstName" name="firstName" type="firstName"  {...register("firstName", { required: true })} required className="block w-full rounded-md border-0  text-black lowercase shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="FirstName" />
                    </div>
                </div>

                <div>
                    <div className="mt-2">
                        <input id="lastName" name="lastName" type="lastName"  {...register("lastName", { required: true })} required className="block w-full rounded-md border-0  text-black shadow-sm lowercase ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="LastName" />
                    </div>
                </div>

                <div>
                    <div className="mt-2">
                        <input id="email" name="email" type="email"  {...register("email", { required: true })} autoComplete="email" required className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Email" />
                    </div>
                </div>
                {state && state.role && <div>
                    <p>Business Detail</p>
                    <div className="mt-2 flex items-center justify-center">
                    {/* <button id="dropdown-phone-button" data-dropdown-toggle="dropdown-phone" className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">
                                <svg className="w-5 h-5" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#f0f0f0" r="256" /><path d="m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z" fill="#ff9811" /><path d="m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z" fill="#6da544" /><circle cx="256" cy="256" fill="#0052b4" r="89.043" /><circle cx="256" cy="256" fill="#f0f0f0" r="55.652" /><path d="m256 187.326 17.169 38.938 42.304-4.601-25.136 34.337 25.136 34.337-42.304-4.601-17.169 38.938-17.169-38.938-42.304 4.6 25.136-34.336-25.136-34.337 42.304 4.601z" fill="#0052b4" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
                                +91 <svg className="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" /></svg>
                            </button>
                        <input id="phone" name="phone" type="phone"  {...register("phone", { required: true })} autoComplete="phone" required className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Phone Number" /> */}
                  {!varified &&  <div
                        style={{ display: show ? "block" : "flex" }}
                    >
                        {/* <label htmlFor="user" className="mt-2 block text-sm font-medium leading-6" id="user">Verify your phone number</label> */}
                        <div className="flex items-center justify-center">
                            <button id="dropdown-phone-button" data-dropdown-toggle="dropdown-phone" className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">
                                <svg className="w-5 h-5" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#f0f0f0" r="256" /><path d="m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z" fill="#ff9811" /><path d="m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z" fill="#6da544" /><circle cx="256" cy="256" fill="#0052b4" r="89.043" /><circle cx="256" cy="256" fill="#f0f0f0" r="55.652" /><path d="m256 187.326 17.169 38.938 42.304-4.601-25.136 34.337 25.136 34.337-42.304-4.601-17.169 38.938-17.169-38.938-42.304 4.6 25.136-34.336-25.136-34.337 42.304 4.601z" fill="#0052b4" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
                                +91 <svg className="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" /></svg>
                            </button>
                            <div className="relative">
                                <input
                                    name="phone"
                                    // value={mynumber}
                                    // onChange={(e) => {
                                    //     setnumber(e.target.value);
                                    // }}
                                    {...register("phone", { required: true })}
                                    type="string" autoComplete="phone" id="phone-input" class="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" maxLength={10} pattern="/^\d{10}$/" placeholder="xxxxxxxxxx" required />
                            </div>
                        </div>

                        <button
                            type="button"
                            style={{
                                display: show ? "none" : "block",
                            }}
                            className=" p-1 items-center justify-center font-medium bg-red-700 text-white hover:text-white"
                            onClick={() => verify()}>
                            Send OTP
                        </button>
                        <br />

                        <div id="recaptcha-container"></div>
                        <div
                        style={{
                            display: show ? "block" : "none",
                        }}
                        className="flex sm:mx-auto sm:w-full sm:max-w-sm"
                    >
                        {!varified ? <input
                            type="text"
                            placeholder={"Enter the OTP you received"}
                            onChange={(e) => {
                                setotp(e.target.value);
                            }}
                            name="otp"
                            autoComplete="one-time-code"
                            maxLength="6"
                            inputMode="numeric"
                            className="block w-full rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />:""}
                        <br />
                        
                       {showloader == true ? <button
                            type="button"
                            className="p-1 font-medium bg-indigo-600 text-white hover:text-indigo-500"
                            onClick={() => ValidateOtp()}>
                            Verify
                        </button>:""}
                    </div>
                    </div>}
                    </div>
                    {/* <div className="mt-2">
                        <input id="adhar" name="adharnumber" type="adharnumber"  {...register("adharnumber", {
                            pattern: {
                                value: /^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/,
                                message: 'Please enter valid adhar number',
                            }
                        })} autoComplete="adharnumber" className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Adhar Card Number XXXX XXXX 1234" />
                        {errors.adharnumber && <p className="text-red">{errors.adharnumber.message}</p>}
                    </div> */}
                    <div className="mt-2">
                        <input id="address" name="address" type="address"  {...register("address", { required: true })} autoComplete="address" required className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Address" />
                    </div>
                    <div className="mt-2">
                        <input id="type" name="type" type="type"  {...register("type", { required: true })} autoComplete="type" required className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Company Name" />
                    </div>
                    <div className="mt-2">
                        <input id="pincode" name="pincode" type="pincode"  {...register("pincode", { required: true })} autoComplete="pincode" required className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Pin Code" />
                    </div>
                    <div className="mt-2">
                        <input id="state" name="state" type="state"  {...register("state", { required: true })} autoComplete="state" required className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="State" />
                    </div>
                    <div className="mt-2">
                        <input id="city" name="city" type="city"  {...register("city", { required: true })} autoComplete="city" required className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="City" />
                    </div>
                    <div className="mt-2">
                        <label>Product Type</label>
                        <select type="text" {...register("products_type", { required: true })} className="h-10 block border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none p-2">
                            <option disabled>Organic Products</option>
                            <option value="Spice Masala">Spice Masala</option>
                            <option value="Organic Products">Organic Products</option>
                            <option value="Dry Fruits">Dry Fruits</option>
                            <option value="Healthy Snacks">Healthy Snacks</option>
                            <option disabled>Handloom Products</option>
                            <option value="Bags or Purse">Bags or Purse</option>
                            <option value="Womens Products">Womens Products</option>
                            <option value="Skin Care">Skin Care</option>
                            <option value="Mens Products">Mens Products</option>
                            <option value="Ceramics Products">Ceramics Products</option>
                            <option value="HomeDecor Products">HomeDecor and Temples Products</option>
                            <option value="Toys">Toys Products</option>
                            <option value="Baby Products">kids Products</option>
                            <option value="Art or Customized Products">Art or Customized Products</option>
                        </select>
                    </div>
                    <div>
                    <input name="password" type="password" {...register("password", {
                        required: true, minLength: {
                            value: 8,
                            message: "Please enter min 8 characters"
                        }, pattern: {
                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                            message: 'Password must contain uppercase, lowercase, number, and special character',
                        },
                    })} required class="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Enter password" />

                </div>
                {errors.password && <p className="text-red">{errors.password.message}</p>}
                <input
                    name="password_repeat"
                    type="password"
                    {...register("password_repeat",
                        {
                            validate: value =>
                                value === password || "The passwords do not match"
                        }
                    )}
                    placeholder="Repeat password"
                    className="block w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2"
                />
                {errors.password_repeat && <p className="text-red">{errors.password_repeat.message}</p>}
                </div>}
                {/* <RegisterOtp/> */}


                {props.varified &&
                    <div className="flex mt-7 mb-5">
                        <button type="submit" className="w-full h-12 bg-indigo-600 hover:bg-indigo-900 transition-all duration-700 rounded-full shadow-xs text-white text-base font-semibold leading-6" onClick={handleSubmit(onSubmit)}>Submit</button>
                    </div>
                }
                {state && state.role && varified && <div className="flex mt-7 mb-5">
                    <button type="submit" className="w-full h-12 bg-indigo-600 hover:bg-indigo-900 transition-all duration-700 rounded-full shadow-xs text-white text-base font-semibold leading-6" onClick={handleSubmit(onSubmit)}>Submit</button>
                </div>}

            </form>
        </div>
    )
}

export default Signin